import { bool, func, object, string } from 'prop-types';

import { ListGroupItem, ListGroupItemHeading, ListGroupItemText, Button } from 'twyne-new.ui';

export default function ThemeItem({ name, theme, active, onClick }) {
  return <ListGroupItem action color={active ? 'primary' : undefined}>
    <div className='flex justify-between'>
      <div className='flex flex-col gap-0.5'>
        <ListGroupItemHeading>{theme.name || name}</ListGroupItemHeading>
        <ListGroupItemText>{name}</ListGroupItemText>
      </div>
      <div className='flex items-center'>
        {active ? <Button size="sm" disabled variant='light'>
          In use
        </Button> : <Button size="sm" color="accent" onClick={() => onClick(name)} variant='light'>
          Select
        </Button>}
      </div>
    </div>
  </ListGroupItem>
}

ThemeItem.propTypes = {
  name: string,
  theme: object,
  active: bool,
  onClick: func,
};

ThemeItem.defaultProps = {};
